
import {defineComponent} from "vue";
import {TextWithImageAbstractRestDto} from "@/api/pharma-cms-content-page/models";
import ButtonContentPagePreview from "@/components/layouts/content-pages/ButtonContentPagePreview.vue";
import {UtilityRestService} from "@/services/rest/cms-utility/UtilityRestService";
import {DocumentRestService} from "@/services/rest/master/DocumentRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "CpAbstractsOverviewItem",
  components: {ButtonContentPagePreview},
  emits: ["exceptions", "selectedCp"],
  data() {
    return {
      docType: 'PAGE_IMG' as string,
      publicUrl: null as string | null,

      contentPageAbstractContent: '' as string
    }
  },
  props: {
    contentPage: {
      type: Object,
      required: true,
    },
    isLibrary: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted() {
    this.fetchPublicUrl();
    if (this.contentPageAbstract) {
      this.truncateContent();
    }
  },
  watch: {
    contentPageAbstract(newValue) {
      if (newValue) {
        this.truncateContent();
      }
    }
  },
  computed: {
    contentPageAbstract(): TextWithImageAbstractRestDto {
      return this.contentPage.cp_abstract;
    }
  },
  methods: {
    async fetchPublicUrl() {
      try {
        if (this.contentPageAbstract?.image_key) {
          this.publicUrl = await DocumentRestService.getInstance()
            .findPublicPreviewUrl(this.contentPageAbstract.image_key, DpModuleEnum.CMS);
        }
      } catch (exceptions: any) {
        this.$emit('exceptions', exceptions);
      }
    },
    async truncateContent(): Promise<void> {
      this.contentPageAbstractContent = await UtilityRestService.getInstance()
        .truncateHtml(this.contentPageAbstract?.content ?? '', 300);
    }
  }
})
